var _rect, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutstandingBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.689453,
    y: 0.5,
    width: 12,
    height: 14,
    rx: 1.5,
    stroke: "#42328A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.68945,
    y1: 4.5,
    x2: 9.68945,
    y2: 4.5,
    stroke: "#42328A",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.68945,
    y1: 7.5,
    x2: 9.68945,
    y2: 7.5,
    stroke: "#42328A",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.68945,
    y1: 10.5,
    x2: 6.68945,
    y2: 10.5,
    stroke: "#42328A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstandingBills);
export default __webpack_public_path__ + "static/media/outstanding-bills.ed9c9ffa31255fc26da7df94cb0027db.svg";
export { ForwardRef as ReactComponent };